import { useState, useRef, useEffect } from 'react'
import { Tags } from 'lucide-react'

const MERGE_TAG_CATEGORIES = [
  {
    label: 'Contact',
    tags: [
      { tag: '{{first_name}}', label: 'First Name' },
      { tag: '{{last_name}}', label: 'Last Name' },
      { tag: '{{full_name}}', label: 'Full Name' },
      { tag: '{{email}}', label: 'Email' },
      { tag: '{{phone}}', label: 'Phone' },
    ]
  },
  {
    label: 'Company',
    tags: [
      { tag: '{{company_name}}', label: 'Company Name' },
      { tag: '{{company_website}}', label: 'Website' },
      { tag: '{{company_address}}', label: 'Address' },
    ]
  },
  {
    label: 'Campaign',
    tags: [
      { tag: '{{unsubscribe_link}}', label: 'Unsubscribe Link' },
      { tag: '{{view_in_browser}}', label: 'View in Browser' },
      { tag: '{{current_date}}', label: 'Current Date' },
      { tag: '{{current_year}}', label: 'Current Year' },
    ]
  },
  {
    label: 'Custom',
    tags: [
      { tag: '{{custom_1}}', label: 'Custom Field 1' },
      { tag: '{{custom_2}}', label: 'Custom Field 2' },
      { tag: '{{custom_3}}', label: 'Custom Field 3' },
    ]
  }
]

export default function MergeTagDropdown({ onInsert }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          setOpen(!open)
        }}
        title="Insert merge tag"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '26px',
          height: '26px',
          border: 'none',
          borderRadius: '4px',
          background: open ? '#e2e8f0' : 'transparent',
          color: open ? 'var(--color-primary)' : '#475569',
          cursor: 'pointer',
          padding: 0
        }}
      >
        <Tags size={14} />
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          marginTop: '4px',
          width: '220px',
          maxHeight: '280px',
          overflowY: 'auto',
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          zIndex: 100
        }}>
          {MERGE_TAG_CATEGORIES.map(cat => (
            <div key={cat.label}>
              <div style={{
                padding: '6px 12px 4px',
                fontSize: '0.65rem',
                fontWeight: '700',
                color: '#94a3b8',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                borderBottom: '1px solid #f1f5f9'
              }}>
                {cat.label}
              </div>
              {cat.tags.map(t => (
                <button
                  key={t.tag}
                  onMouseDown={(e) => {
                    e.preventDefault()
                    onInsert(t.tag)
                    setOpen(false)
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '6px 12px',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: '0.8rem',
                    color: '#1e293b',
                    textAlign: 'left'
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.background = '#f1f5f9' }}
                  onMouseOut={(e) => { e.currentTarget.style.background = 'transparent' }}
                >
                  <span>{t.label}</span>
                  <code style={{
                    fontSize: '0.65rem',
                    color: '#6366f1',
                    background: '#eef2ff',
                    padding: '1px 4px',
                    borderRadius: '3px'
                  }}>
                    {t.tag}
                  </code>
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export { MERGE_TAG_CATEGORIES }
